<section class="aarni-font w-full shadow border-b  py-[50px] mt-[80px]">
    <div class="container mx-auto px-4">
        <h1 class=" text-center md:text-start font-bold text-[32px]">
            {{ pageTitle }}
        </h1>

    </div>
</section>

<section class="aarni-font">
    <div class="container mx-auto flex flex-col lg:flex-row gap-8 py-12 px-4">
        <aside class="w-full lg:w-1/4 space-y-4 h-fit overflow-y-auto">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">Study Abroad</h2>
                    <div class="">
                        <a [href]="'/about/act-statutes-ordinances'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Act, Statutes and Ordinances', 'text-blue-600 bg-white' : pageTitle !== 'Act, Statutes and Ordinances'}"
                             class="flex items-center space-x-2 p-3 w-full border-y border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Act, Statutes and Ordinances</span>
                        </a>
                        <a [href]="'/about/organizational-structure'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Organizational Structure', 'text-blue-600 bg-white' : pageTitle !== 'Organizational Structure'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Organizational Structure</span>
                        </a>
                        <a [href]="'/about/rti'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'RTI', 'text-blue-600 bg-white' : pageTitle !== 'RTI'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>RTI</span>
                        </a>
                        <a [href]="'/about/best-practice'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Best Practices', 'text-blue-600 bg-white' : pageTitle !== 'Best Practices'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Best Practices</span>
                        </a>
                        <a [href]="'/about/analytical-center'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Analytical Center', 'text-blue-600 bg-white' : pageTitle !== 'Analytical Center'}"
                             class="flex items-center space-x-2 p-3 w-full  border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Analytical Center</span>
                        </a>
                    </div>
                </div>
            </div>
            <h2 class="text-lg font-semibold mb-4">Quick Links</h2>
            <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/about/faculty" class="flex items-center  space-x-3 p-2 rounded-lg">
                        <span class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        <span class="text-gray-700 font-medium pl-4 text-xl">Faculty</span>
                    </a>
                </div>
            </div>

            <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/student-testimonial" class="flex items-center space-x-3 p-2 rounded-lg">
                        <span class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        <span class="text-gray-700 font-medium text-xl pl-4">Testimonials</span>
                    </a>
                </div>
            </div>

            <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/about/leadership/chancellor" class="flex items-center space-x-3 p-2 rounded-lg ">
            <span class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-phone text-2xl"></i>
            </span>
                        <span class="text-gray-700 font-medium pl-4 text-xl">Leadership</span>
                    </a>
                </div>
            </div>

            <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/contact-us" class="flex items-center space-x-3 p-2 rounded-lg ">
            <span class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-camera text-2xl"></i>
            </span>
                        <span class="text-gray-700 font-medium pl-4 text-xl">Contact Us</span>
                    </a>
                </div>
            </div>
        </aside>
        <div class="flex-1">
            <div class="p-12 shadow-lg border-gray-200 bg-white h-fit border">
                <h3 class="font-semibold text-[22px]">
                    {{ pageTitle }}
                </h3>

                <div class="mt-10 border-gray-200 border" *ngIf="pageTitle === 'Act, Statutes and Ordinances'">
                    <div *ngFor="let section of actSections; let i = index">
                        <button
                            class="w-full flex items-center p-2"
                            (click)="toggleAccordion(i)"
                        >
                            <i class="text-lg"
                               [ngClass]="activeIndex === i ? 'fas fa-minus text-blue-500' : 'fas fa-plus text-blue-500'"

                            ></i>
                            <span class="ml-2 text-start font-bold text-lg md:text-xl">{{
                                    section.heading
                                }}</span>
                        </button>
                        <div
                            *ngIf="activeIndex === i"
                            @fadeInOut
                            class="p-2 text-gray-700 sm:text-sm"
                            [innerHTML]="section.content"
                        ></div>
                        <hr *ngIf="i < actSections.length - 1"/>
                    </div>
                </div>

                <div class="mt-10 border-gray-200 border" *ngIf="pageTitle === 'Best Practices'">
                    <div *ngFor="let section of bestPracticesSections; let i = index">
                        <button
                            class="w-full flex items-center p-2"
                            (click)="toggleAccordion(i)"
                        >
                            <i class="text-lg"
                               [ngClass]="activeIndex === i ? 'fas fa-minus text-blue-500' : 'fas fa-plus text-blue-500'"

                            ></i>
                            <span class="ml-2 text-start font-bold text-lg md:text-xl">{{
                                    section.heading
                                }}</span>
                        </button>
                        <div
                            *ngIf="activeIndex === i"
                            @fadeInOut
                            class="p-2 text-gray-700 sm:text-sm"
                            [innerHTML]="section.content"
                        ></div>
                        <hr *ngIf="i < bestPracticesSections.length - 1"/>
                    </div>
                </div>

                <div class="" *ngIf="pageTitle === 'Organizational Structure'">
                    <div class="overflow-hidden">
                        <img src="./assets/img/info-about/organizational-structure.png" class="w-full h-auto"
                             alt="Organization structure">
                    </div>
                </div>

                <div class="" *ngIf="pageTitle === 'RTI'">
                    <div class="mt-10">
                    <p class="text-[12px] text-red-500 underline">
                        <i class="fa-solid fa-file-pdf mr-2"></i> UP University Act 2025
                    </p>
                    </div>
                </div>


            </div>
        </div>
    </div>
</section>
